export default {
  'es-US': () => import('./translations_es-US.json'),

  'ja-JP': () => import('./translations_ja-JP.json'),

  'zh-CN': () => import('./translations_zh-CN.json'),

  'zh-TW': () => import('./translations_zh-TW.json'),
}